export interface JSONCensusCSVImportResult {
	listEntriesCodeNotValid: NotValidEntries;
	listEntriesGuidValid: string[];
}

export interface CensusCSVImportResult {
	listEntriesCodeNotValid: CSVImportErrorResult[];
	listEntriesGuidValid: string[];
}

export interface CSVImportErrorResult {
	deviceCode: string;
	reason: string;
}

interface NotValidEntries {
	[key: string]: string;
}

export const JSONCensusCSVImportResultIntoCensusCSVImportResult = (
	result: JSONCensusCSVImportResult,
): CensusCSVImportResult => {
	const listEntriesCodeNotValid: CSVImportErrorResult[] = [];

	if (result?.listEntriesCodeNotValid) {
		Object.keys(result.listEntriesCodeNotValid).forEach((key) => {
			listEntriesCodeNotValid.push({
				deviceCode: key,
				reason: result.listEntriesCodeNotValid[key],
			});
		});
	}

	return {
		listEntriesCodeNotValid: listEntriesCodeNotValid,
		listEntriesGuidValid: result.listEntriesGuidValid,
	};
};
